<div [ngClass]="class" [style.zIndex]="zIndex || 0" class="snack-item">
  @if (data?.context) {
    <div [innerHTML]="data?.context" class="snack-header"></div>
  }
  <div [innerHTML]="data?.text" class="snack-content"></div>
  @if (isProgressBar) {
    <div class="snack-progress">
      <div class="progress-container">
        <div class="progress-value">{{ spinner.value / 100 | percent }}</div>
        <mat-progress-bar #spinner [value]="data.progress" color="#00b8c9" mode="determinate"></mat-progress-bar>
      </div>
    </div>
  }
  @if (data?.action) {
    <button (click)="clickAction()" class="action-button danger">{{ data?.action?.text }}</button>
  }
  <div class="snack-date">{{ data?.date | date: "MMM d, y, HH:mm" }}</div>

  @if (!isProgressBar) {
    <button (click)="closeNotification()" class="icon-button icon-close"></button>
  }
</div>
